import { useEffect, useState } from 'react';

export function useResendCooldown(key = 'verifyEmailCooldownUntil', duration = 60) {
  const [remaining, setRemaining] = useState(0);

  // Calculate cooldown on load
  useEffect(() => {
    const stored = sessionStorage.getItem(key);
    const now = Date.now();

    if (stored) {
      const targetTime = parseInt(stored, 10);
      const diff = Math.floor((targetTime - now) / 1000);
      setRemaining(diff > 0 ? diff : 0);
    }
  }, [key]);

  // Countdown timer
  useEffect(() => {
    if (remaining <= 0) return;
    const timer = setTimeout(() => setRemaining((r) => r - 1), 1000);
    return () => clearTimeout(timer);
  }, [remaining]);

  // Start cooldown
  const triggerCooldown = () => {
    const now = Date.now();
    const cooldownUntil = now + duration * 1000;
    sessionStorage.setItem(key, `${cooldownUntil}`);
    setRemaining(duration);
  };

  return [remaining, triggerCooldown];
}
